import React from "react";
import { useChatSocket } from "../hooks/useChatSocket";
import { showInfo } from "toast/toast";
import { getAuthCookie } from "../utils/authCookies";

/**
 * Global listener that connects to the chat/notification websocket
 * and shows a toast whenever the logged-in user receives a notification.
 * Also dispatches a window event so other components (badge, list) can react.
 */
const NotificationSocketListener: React.FC = () => {
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");

  useChatSocket({
    token,
    onNotification: (msg: any) => {
      // Backend can choose any shape; try common patterns defensively.
      const payload = msg.notification || msg.data || msg;

      // If backend includes a user_id, ensure it matches current user.
      if (payload?.user_id && userId && payload.user_id !== userId) {
        return;
      }

      // Fire a custom event so headers / pages can update counts in real time
      if (typeof window !== "undefined") {
        window.dispatchEvent(
          new CustomEvent("realesy:notification", { detail: payload })
        );
      }

      const title =
        payload?.title ||
        payload?.text ||
        payload?.message ||
        "New notification";
      const body: string = payload?.text || payload?.message || "";

      const message =
        body && body !== title ? `${title}: ${body}` : title;

      showInfo(message);
    },
    onChatMessage: () => {
      // Chat messages can be handled elsewhere if needed.
    },
  });

  return null;
};

export default NotificationSocketListener;

